import Plot from "react-plotly.js";
import { HeatMapDataType } from "@/pages/biReports/types";

type HeatmapProps = {
  title?: string;
  data: HeatMapDataType;
  colorscale?: string;
  height?: number;
  width?: number;
  ariaLabel?: string;
};

export const Heatmap = ({ title, data, colorscale = "Blues", height = 400, width = 600, ariaLabel }: HeatmapProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const PlotComponent = Plot as any;
  
  // Calculate the midpoint of the data range for determining text color
  const maxValue = Math.max(...data.z.flat());
  const threshold = maxValue * 0.3; // Use dark text for values below 30% of max
  
  return (
    <div role="img" aria-label={ariaLabel || title || "Heatmap chart"}>
      <PlotComponent
        data={[
          {
            z: data.z,
            x: data.x,
            y: data.y,
            type: "heatmap",
            colorscale,
            reversescale: true,
            hoverongaps: false,
            showscale: false,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            text: data.z.map(row => row.map(val => val.toString())) as any, // matrix of strings
            texttemplate: "%{text}",
            textfont: {
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              color: data.z.map(row => row.map(val => val === 0 ? "#9ca3af" : val <= threshold ? "black" : "white")) as any, // gray for 0, black for low values, white for high values
              size: 12,
            },
            zmin: 0,
            zmax: maxValue,
          },
        ]}
        layout={{
          title: { text: title, font: { size: 18 } },
          height,
          width,
          margin: { t: 40, l: 80 },
        }}
        config={{ displayModeBar: false }}
      />
    </div>
  );
};